import { AuthenticatedApiCaller } from "./authenticatedApiCaller";

export default class ApiCallerWithBaseUrl{

    baseUrl: string;

    constructor(baseUrl: string){
        this.baseUrl = baseUrl;
    }

    caller = new AuthenticatedApiCaller();

    postJson(url: string, token: string | null, payload: any, headers?: {}): Promise<Response>{

        url = this.baseUrl + url;

        return this.caller.postJson(url, token, payload, headers);
    }

    getJson(url: string, token: string | null, queryParameters?: {}, headers?: {}): Promise<Response>{
        url = this.baseUrl + url;
        
        return this.caller.getJson(url, token, queryParameters, headers);
    }

    downloadFile(url: string, token: string | null, queryParameters?: {}, headers?: {}): Promise<Response>{

        url = this.baseUrl + url;

        return this.caller.downloadFile(url, token, queryParameters, headers);
    }
}